import { ShieldCheck } from "lucide-react";
import PageHeader from "../components/PageHeader";
import TwoFactorCard from "../components/security/TwoFactorCard";

export default function AccountSecurityPage() {
  return (
    <div className="p-6 max-w-3xl mx-auto" data-testid="account-security-page">
      <PageHeader title="Sécurité de mon compte" subtitle="Double authentification, codes de secours et appareils de confiance." icon={<ShieldCheck />} />
      <TwoFactorCard />
    </div>
  );
}
